<template>
  <div
    v-if="!!ta_score"
    class="pop-ta-score-label"
  >
    <div class="pop-ta-score-label__value">{{ ta_score }}/20</div>
    <v-menu
      open-on-hover
      :close-delay="150"
      bottom
      offset-y
      content-class="elevation-0"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          class="pop-ta-score-label__label pop-ta-score-label__label--tooltip"
          v-bind="attrs"
          v-on="on"
        >
          <span>Trust & Authority Score™</span>
          <i class="material-icons pop-ta-score-label__info-icon">info_outline</i>
        </div>
      </template>
      <div class="white-bg-tooltip small-tooltip pop-ta-score-label__tooltip-bubble">
        <div class="pop-ta-score-label__tooltip-text">
          <p><strong>POP Trust & Authority Score™</strong> measures your website's Trust and Authority on a scale of 1 to 20. We use it to identify keywords Google should immediately trust your site to rank for.</p> <p>In most cases, you can rank easily for keywords with a TA Score at or below your site's score, so a 3/20 site should target keywords rated 3 or under for the quickest wins. Keep in mind that TA Scores apply only to supporting keywords, not top-level keywords. Top-level keywords are driven by necessity (every site in a niche has to have them), so the score doesn't matter there. Supporting keywords are where you have control, and they're what help you build authority for the top-level terms you're required to rank for.</p>
        </div>
        <a
          class="pop-ta-score-label__tooltip-link"
          href="https://help.pageoptimizer.pro/article/pop-impact-score"
          target="_blank"
          rel="noopener noreferrer"
        >Learn more about POP Trust & Authority Score™</a>
      </div>
    </v-menu>
  </div>
</template>

<script>

export default {
  props: {
    ta_score: {
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.pop-ta-score-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 0;
  padding: 16px 18px;
  background: #fff;
  border: 1px solid var(--v-gray12Color-base);
  border-radius: 12px;
}

.pop-ta-score-label__value {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--v-mainColor-base);
  line-height: 1.3;
}

.pop-ta-score-label__label {
  margin-top: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--v-gray2Color-base, #757575);
  letter-spacing: 0.02em;
}

.pop-ta-score-label__label--tooltip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: help;
}

.pop-ta-score-label__info-icon {
  font-size: 14px;
  opacity: 0.65;
}

.pop-ta-score-label__tooltip-bubble {
  max-width: 400px;
  border: 1px solid var(--v-gray12Color-base);
  padding: 16px;
}

.pop-ta-score-label__tooltip-text {
  font-size: 0.85rem;
  line-height: 1.4;
}

.pop-ta-score-label__tooltip-link {
  display: inline-block;
  margin-top: 10px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--v-profileAnchorColor-base);
  text-decoration: none;
}

.pop-ta-score-label__tooltip-link:hover {
  text-decoration: underline;
}
</style>
